<template>
  <div>
    <nav class="w3-sidebar w3-collapse w3-animate-left gunmetal navPadding noselect" style="z-index:5; width:14.5rem;" id="mySidebar">
      <a class="w3-padding w3-black w3-block" @click="store.toggleMenu()" v-if="state.width < 1025">
        <i class="fas fa-times fa-fw"></i><span class="nav-text">Close Menu</span>
      </a>
      <div class="w3-row w3-padding-8">
        <div class="w3-col s12">
          <template v-if="state.user.companyLogo && state.user.companyLogo !== ''">
            <img :src="state.user.companyLogo" style="max-width:100%;">
          </template>
          <template v-else>
            <img src="@/assets/logo-white.png" style="max-width:100%; margin-left:3px;">
          </template>
        </div>
      </div>

      <!-- Account View -->
      <template v-if="!state.cmsView">
        <!-- Admin Menu -->
        <template v-if="state.user.isAdmin && !state.fakeClient">
          <div class="w3-padding-h w3-padding-bottom" style="color:#aaa; font-size:10pt;">Main</div>
          <div class="w3-bar-block sidebarMenu">
            <button class="w3-bar-item" @click="store.toggleMenu(); $router.push('/')" :style="$route.path === '/' ? 'background:#172a3e' : ''">
              <i class="fas fa-home fa-fw"></i><span class="nav-text">Dashboard</span>
            </button>
            <router-link tag="button" to="/clients" class="w3-bar-item" @click.native="store.toggleMenu('client');">
              <i class="fas fa-users fa-fw"></i><span class="nav-text">Clients</span>
            </router-link>
            <router-link tag="button" to="/subscriptions" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-shopping-cart fa-fw"></i><span class="nav-text">Subscriptions</span>
            </router-link>
            <router-link tag="button" to="/invoices" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-file-invoice-dollar fa-fw"></i><span class="nav-text">Invoices</span>
            </router-link>
            <router-link tag="button" to="/products" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-cubes fa-fw"></i><span class="nav-text">Products</span>
            </router-link>
            <router-link tag="button" to="/sites" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-server fa-fw"></i><span class="nav-text">Websites</span>
            </router-link>
            <router-link tag="button" to="/config" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-cog fa-fw"></i><span class="nav-text">Config</span>
            </router-link>
            <br/>
            <button class="w3-bar-item w3-button" @click="store.signOut()">
              <i class="fas fa-sign-out-alt fa-fw"></i><span class="nav-text">Sign Out</span>
            </button>
          </div>
        </template>

        <!-- User Menu -->
        <template v-else>
          <div class="w3-padding-h w3-padding-bottom" style="color:#aaa; font-size:10pt;">Main</div>
          <div class="w3-bar-block sidebarMenu">
            <button class="w3-bar-item" @click="store.toggleMenu(); $router.push('/')" :style="$route.path === '/' ? 'background:#172a3e' : ''">
              <i class="fas fa-desktop fa-fw"></i><span class="nav-text">Dashboard</span>
            </button>
            <router-link tag="button" to="/billing" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-file-invoice fa-fw"></i><span class="nav-text">Billing</span>
            </router-link>
            <!-- <router-link tag="button" to="/domains" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-globe fa-fw"></i><span class="nav-text">Domains</span>
            </router-link>
            <router-link tag="button" to="/email" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-envelope fa-fw"></i><span class="nav-text">Email</span>
            </router-link> -->
            <router-link tag="button" to="/sites" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-server fa-fw"></i><span class="nav-text">Websites</span>
            </router-link>
            <!-- <router-link tag="button" to="/services" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-box-open fa-fw"></i><span class="nav-text">Other Services</span>
            </router-link> -->
            <router-link tag="button" to="/support" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-question-circle fa-fw"></i><span class="nav-text">Support</span>
            </router-link>
            <!-- <button class="w3-bar-item" @click="test()">
              <i class="fas fa-cog fa-fw"></i><span class="nav-text">Test</span>
            </button> -->
            <div class="w3-padding" style="color:#aaa; font-size:10pt;">User</div>
            <button class="w3-bar-item w3-button" @click="store.signOut();">
              <i class="fas fa-sign-out-alt fa-fw"></i><span class="nav-text">Sign Out</span>
            </button>
          </div>
        </template>
      </template>

      <!-- CMS View -->
      <template v-else>
        <div class="w3-bar-block sidebarMenu">
          <a class="w3-bar-item" @click="store.toggleMenu();" :href="'https://levelsevenstudio.com/frontend/?domain=' + state.activeSite.domain" target="_blank">
            <i class="fas fa-external-link-alt fa-fw"></i><span class="nav-text">Preview Site</span>
          </a>
        </div>
        <div class="w3-bar-block sidebarMenu">
          <div class="w3-bar-item menuHeader">Main</div>
          <button class="w3-bar-item" @click="store.toggleMenu(); $router.push('/cms')" :style="$route.path === '/cms' ? 'background:#172a3e' : ''">
            <i class="fas fa-desktop fa-fw"></i><span class="nav-text">Dashboard</span>
          </button>
          <!-- <router-link tag="button" to="/cms/analytics" class="w3-bar-item" @click.native="store.toggleMenu()">
            <i class="fas fa-chart-line fa-fw"></i><span class="nav-text">Analytics</span>
          </router-link> -->
          <router-link tag="button" to="/cms/leads" v-if="state.user.isAdmin || state.siteData.content.leads.enabled" class="w3-bar-item" @click.native="store.toggleMenu()">
            <i class="fas fa-inbox fa-fw"></i><span class="nav-text">Leads</span>
          </router-link>
          <div class="w3-bar-item menuHeader">Content</div>
          <!-- <div class="w3-bar-item" :class="[pagesSubMenu ? 'submenuActive':'',$router.currentRoute.name === 'cmsPages' ? 'router-link-active' : '']" @click="toggleSubMenuPages()">
            <i class="fas fa-copy fa-fw"></i><span class="nav-text">Pages</span><span class="w3-right subMenuIcon" :class="pagesSubMenu ? 'active' : ''"><i class="fa fa-chevron-left"></i></span>
          </div> -->
          <div class="w3-bar-item" style="padding:0;" :class="[pagesSubMenu ? 'submenuActive':'', $router.currentRoute.name === 'cmsPages' ? 'router-link-active' : '']">
            <div class="subGrid">
              <router-link tag="div" to="/cms/pages" @click.native="navPages()" :class="pagesSubMenu ? 'submenuActive':''" style="padding:9px 15px;"><i class="fas fa-copy fa-fw"></i><span class="nav-text">Pages</span></router-link>
              <div class="text-center" style="padding:9px 15px;" @click="toggleSubMenuPages()"><span class="subMenuIcon"><i class="fa fa-chevron-left" :class="pagesSubMenu ? 'active' : ''"></i></span></div>
            </div>
          </div>
          <!-- <transition name="menuslide"> -->
            <div class="w3-bar-block submenu" :class="pagesSubMenu ? 'active':''" v-if="pagesSubMenu" v-anime="{ translateY: '0', duration: 300, loop: false }">
              <div class="w3-bar-item" :class="state.pagesView === 'home' ? 'router-link-active' : ''" @click="pagesView('home')" style="border-radius:5px 5px 0 0;">
                <i class="fas fa-file fa-fw"></i><span class="nav-text">Home</span>
              </div>
              <div v-for="(page, index) in state.siteData.site_pages" :key="index" class="w3-bar-item" :class="state.pagesView === page ? 'router-link-active' : ''" @click="pagesView(page)" style="text-transform:capitalize;">
                <i class="fas fa-file fa-fw"></i><span class="nav-text">{{page}}</span>
              </div>
              <template v-if="state.siteData.pages.repairs && state.siteData.pages.repairs.enabled">
                <div class="w3-bar-item" :class="state.pagesView === 'repairs' ? 'router-link-active' : ''" @click="pagesView('repairs')" style="text-transform:capitalize;">
                  <i class="fas fa-file fa-fw"></i><span class="nav-text">Repairs</span>
                </div>
              </template>
            </div>
          <!-- </transition> -->
          <router-link tag="button" to="/cms/services" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.services.enabled">
            <i class="fas fa-box-open fa-fw"></i><span class="nav-text">Services</span>
          </router-link>
          <div class="w3-bar-item" style="padding:0;" :class="[shopSubMenu ? 'submenuActive':'', $router.currentRoute.name === 'cmsProducts' ? 'router-link-active' : '']" v-if="state.siteData.content.products.enabled">
            <div class="subGrid">
              <router-link tag="div" to="/cms/products" @click.native="navShop()" :class="shopSubMenu ? 'submenuActive':''" style="padding:9px 15px;"><i class="fas fa-shopping-cart fa-fw"></i><span class="nav-text">Shop</span></router-link>
              <div class="text-center" style="padding:9px 15px;" @click="toggleSubMenuShop()"><span class="subMenuIcon"><i class="fa fa-chevron-left" :class="shopSubMenu ? 'active' : ''"></i></span></div>
            </div>
          </div>
          <transition name="menuslide" v-if="state.siteData.content.products.enabled">
            <div class="w3-bar-block submenu" :class="shopSubMenu ? 'active':''" v-if="shopSubMenu">
              <router-link tag="button" to="/cms/products" class="w3-bar-item" @click.native="store.toggleMenu()">
                <i class="fas fa-tags fa-fw"></i><span class="nav-text">Products</span>
              </router-link>
              <router-link tag="button" to="/cms/product-categories" class="w3-bar-item" @click.native="store.toggleMenu()">
                <i class="fas fa-folder-open fa-fw"></i><span class="nav-text">Categories</span>
              </router-link>
              <router-link tag="button" to="/cms/product-orders" class="w3-bar-item" @click.native="store.toggleMenu()">
                <i class="fas fa-receipt fa-fw"></i><span class="nav-text">Orders</span>
              </router-link>
            </div>
          </transition>
          <router-link tag="button" to="/cms/news" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.news.enabled">
            <i class="fas fa-rss fa-fw"></i><span class="nav-text">News</span>
          </router-link>
          <router-link tag="button" to="/cms/properties" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.properties.enabled">
            <i class="fas fa-building fa-fw"></i><span class="nav-text">Properties</span>
          </router-link>
          <router-link tag="button" to="/cms/calendar" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.events.enabled">
            <i class="fas fa-calendar fa-fw"></i><span class="nav-text">Events</span>
          </router-link>
          <div class="w3-bar-item" :class="portfolioSubMenu ? 'submenuActive':''" @click="toggleSubMenuPortfolio()" v-if="state.siteData.content.portfolio.enabled">
            <i class="fas fa-briefcase fa-fw"></i><span class="nav-text">Portfolio</span>
          </div>
          <transition name="menuslide" v-if="state.siteData.content.portfolio.enabled">
            <div class="w3-bar-block submenu" :class="portfolioSubMenu ? 'active':''" v-if="portfolioSubMenu">
              <router-link tag="button" to="/cms/portfolio" class="w3-bar-item w3-black" @click.native="store.toggleMenu()">
                <i class="fas fa-copy fa-fw"></i><span class="nav-text">Items</span>
              </router-link>
              <router-link tag="button" to="/cms/portfolio-categories" class="w3-bar-item w3-black" @click.native="store.toggleMenu()">
                <i class="fas fa-folder-open fa-fw"></i><span class="nav-text">Categories</span>
              </router-link>
            </div>
          </transition>
          <router-link tag="button" to="/cms/photos" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.photos.enabled">
            <i class="fas fa-images fa-fw"></i><span class="nav-text">Photos</span>
          </router-link>
          <router-link tag="button" to="/cms/videos" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.videos.enabled">
            <i class="fas fa-video fa-fw"></i><span class="nav-text">Videos</span>
          </router-link>
          <router-link tag="button" to="/cms/audio" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.audio.enabled">
            <i class="fas fa-volume-up fa-fw"></i><span class="nav-text">Audio</span>
          </router-link>
          <router-link tag="button" to="/cms/testimonials" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.testimonials.enabled">
            <i class="fas fa-comment-alt fa-fw"></i><span class="nav-text">Testimonials</span>
          </router-link>
          <router-link tag="button" to="/cms/partners" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.partners.enabled">
            <i class="fas fa-handshake fa-fw"></i><span class="nav-text">Partners</span>
          </router-link>
          <router-link tag="button" to="/cms/team" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.team.enabled">
            <i class="fas fa-users fa-fw"></i><span class="nav-text">Team</span>
          </router-link>
          <router-link tag="button" to="/cms/faqs" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.faqs.enabled">
            <i class="fas fa-question-circle fa-fw"></i><span class="nav-text">Faqs</span>
          </router-link>
          <router-link tag="button" to="/cms/documents" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.documents.enabled">
            <i class="fas fa-file-pdf fa-fw"></i><span class="nav-text">Documents</span>
          </router-link>
          <router-link tag="button" to="/cms/contact" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.sidebar.sections.contact.enabled">
            <i class="fas fa-user fa-fw"></i><span class="nav-text">Contact</span>
          </router-link>
          <router-link tag="button" to="/cms/paypal" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.sidebar.sections.paypal.enabled">
            <i class="fab fa-paypal fa-fw"></i><span class="nav-text">PayPal</span>
          </router-link>
          <router-link tag="button" to="/cms/schedules" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.sidebar.sections.schedule.enabled">
            <i class="fas fa-calendar fa-fw"></i><span class="nav-text">Schedule</span>
          </router-link>
          <router-link tag="button" to="/cms/links" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.sidebar.sections.links.enabled">
            <i class="fas fa-globe fa-fw"></i><span class="nav-text">Links</span>
          </router-link>
          <!-- <router-link tag="button" to="/cms/users" class="w3-bar-item" @click.native="store.toggleMenu()" v-if="state.siteData.content.users.enabled">
            <i class="fas fa-user fa-fw"></i><span class="nav-text">Users</span>
          </router-link> -->
          <template v-if="state.user.isAdmin">
            <div class="w3-padding" style="color:#aaa; font-size:10pt;">Style</div>
            <router-link tag="button" to="/cms/colors" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-palette fa-fw"></i><span class="nav-text">Colors</span>
            </router-link>
            <button class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-font fa-fw"></i><span class="nav-text">Fonts</span>
            </button>
          </template>
          <div class="w3-padding" style="color:#aaa; font-size:10pt;">Settings</div>
          <template v-if="state.user.isAdmin">
            <router-link tag="button" to="/cms/settings" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-cogs fa-fw"></i><span class="nav-text">Setup</span>
            </router-link>
          </template>
          <template v-else>
            <router-link tag="button" to="/cms/settingsUser" class="w3-bar-item" @click.native="store.toggleMenu()">
              <i class="fas fa-cogs fa-fw"></i><span class="nav-text">Setup</span>
            </router-link>
          </template>
          <div class="w3-padding" style="color:#aaa; font-size:10pt;">Actions</div>
          <button class="w3-bar-item" @click="store.toggleMenu(); exitBuilder();">
            <i class="fas fa-door-open fa-fw"></i><span class="nav-text">Exit Sitebuilder</span>
          </button>
        </div>
      </template>
    </nav>
  </div>
</template>

<script>
var dataStore = require('../dataStore').default

export default {
  name: 'sidemenu',
  data() {
    return {
      state: dataStore.state,
      store: dataStore,
      shopSubMenu: false,
      pagesSubMenu: false,
      portfolioSubMenu: false
    }
  },
  methods: {
    test() {
      this.$router.push('checkout-success')
    },
    toggleClientFake() {
      dataStore.toggleClientFake()
      this.$router.push('/')
    },
    navShop() {
      if (!this.shopSubMenu) {this.shopSubMenu = true}
      this.store.toggleMenu()
    },
    toggleSubMenuShop() {
      this.shopSubMenu = !this.shopSubMenu
    },
    navPages() {
      if (!this.pagesSubMenu) {this.pagesSubMenu = true}
      this.state.pagesView = 'home'
      this.store.toggleMenu()
    },
    toggleSubMenuPages() {
      this.pagesSubMenu = !this.pagesSubMenu
    },
    toggleSubMenuPortfolio() {
      this.portfolioSubMenu = !this.portfolioSubMenu
    },
    pagesView(page) {
      if (this.$route.name !== 'cmsPages') {
        this.$router.push('/cms/pages')
      }
      this.state.pagesView = page;
      this.store.toggleMenu()
    },
    exitBuilder() {
      dataStore.initSiteData()
      this.state.cmsView = false
      this.pagesSubMenu = false
      this.shopSubMenu = false
      this.$router.push('/')
    }
  },
  filters: {
    firstWord: function(value) {
      if (!value) return ''
      const valArr = value.split(' ')
      const firstVal = valArr[0]
      return firstVal
    }
  }
}
</script>

<style scoped>
  .fas, .fab {margin-right:8px;}
  .nav-text {opacity:0.75; font-weight:500; margin-left:8px;}
  a, .nav-text, button {color: rgba(255,255,255,0.85); font-family: 'Roboto', sans-serif; font-size:13.9px; font-weight:500; text-decoration:none;}
  a:hover {color:rgba(255,255,255,0.85); text-decoration: none;}
  button {background-color: transparent;}
  .w3-bar-block .w3-bar-item {padding:9px 15px; background:#162636; z-index: 1; position:relative;}

  .navPadding {overflow-y: scroll; scrollbar-width: none; -ms-overflow-style: none; padding-bottom:20px;}
  .navPadding::-webkit-scrollbar {width: 0; height: 0;}

  .submenu {z-index: 1;}
  .submenuActive {background: #24313d !important;}
  .submenu .w3-bar-item {background:#091119 !important;}
  .submenu .w3-bar-item.router-link-active {background:#1c252e !important;}

  /* .menuslide-enter-active, .menuslide-leave-active {
    transition: all .3s ease;
    transform: translateY(0);
  }
  .menuslide-enter, .menuslide-leave-to {
    transform: translateY(-100%);
  } */

  .menuHeader {color:#999; font-size:10pt;}
  .subMenuIcon i {color :#aaa; transition: all 0.25s;}
  .subMenuIcon i.active {transform: rotate(-90deg);}
  .subGrid {display:grid; grid-template-columns: 1fr 44px;}

  @keyframes subMenuIconTransition {
    from {background-color: red;}
    to {background-color: yellow;}
  }
</style>



// WEBPACK FOOTER //
// src/components/sidemenu.vue